export default "__VITE_ASSET__BUEaTpxu__"